import * as React from "react";
import { Link } from "react-router-dom";
import { IconButton, Menu, MenuItem, TableCell, Checkbox, } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { MoreVert } from "@material-ui/icons";
import { green, red } from "@material-ui/core/colors";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import { useDeleteTrack, usePublishTracks, useUnpublishTracks, } from "frontend/src/domain/tracks";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { paths } from "frontend/src/pages/paths/index";
import { TrackTableRow } from "frontend/src/ui/track-table-row";
import { GenreEditDialog } from "./genre-edit-dialog";
var formatTrackDate = function (value) {
    if (value === null)
        return "-";
    return new Intl.DateTimeFormat("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(value));
};
var useStyles = makeStyles({
    remove: {
        color: red[700],
    },
    published: {
        color: function (_a) {
            var isPublished = _a.isPublished;
            return (isPublished ? green[500] : red[700]);
        },
    },
});
export var TracksTableRow = function (_a) {
    var index = _a.index, id = _a.id, artist = _a.artist, title = _a.title, ISRC = _a.ISRC, duration = _a.duration, createdAt = _a.createdAt, genres = _a.genres, genreIds = _a.genreIds, isNormalized = _a.isNormalized, isPublished = _a.isApproved, isChecked = _a.isChecked, onCheck = _a.onCheck, isSelectedForPlayer = _a.isSelectedForPlayer, isLoading = _a.isLoading, isPlaying = _a.isPlaying, onPlay = _a.onPlay, onResume = _a.onResume, onPause = _a.onPause, showIsrc = _a.showIsrc;
    var classes = useStyles({ isPublished: isPublished });
    var _b = React.useState(null), anchor = _b[0], setAnchor = _b[1];
    var _c = React.useState(false), isGenreEditDialogOpen = _c[0], setGenreEditDialogOpen = _c[1];
    var handleClick = function (event) {
        setAnchor(event.currentTarget);
    };
    var close = function () { return setAnchor(null); };
    var openGenreEditDialog = function () { return setGenreEditDialogOpen(true); };
    var closeGenreEditDialog = function () { return setGenreEditDialogOpen(false); };
    var remove = useDeleteTrack();
    var publish = usePublishTracks();
    var unpublish = useUnpublishTracks();
    var _d = useConfirmationDialog({
        message: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0440\u0435\u043A \"" + artist + " \u2014 " + title + "\"?",
        onConfirm: function () { return remove.do(id); },
        open: false,
    }), openRemoveDialog = _d.open, Dialog = _d.Dialog;
    var play = function () { return (!isSelectedForPlayer ? onPlay(index) : onResume()); };
    var check = function () { return onCheck(id); };
    var onPublish = function () { return publish.do([id]); };
    var onUnpublish = function () { return unpublish.do([id]); };
    var onRemove = function () { return openRemoveDialog(); };
    return (React.createElement(React.Fragment, null,
        React.createElement(TrackTableRow, { isSelectedForPlayer: isSelectedForPlayer },
            React.createElement(TableCell, { style: { display: "flex" } },
                React.createElement(Checkbox, { checked: isChecked, onChange: check, name: "published", color: "primary" }),
                React.createElement("div", { style: { padding: "6px" } },
                    React.createElement(AudioControlButton, { isLoading: isLoading, onPause: onPause, onPlay: play, isPlaying: isPlaying }))),
            React.createElement(TableCell, null, title),
            React.createElement(TableCell, null, artist),
            React.createElement(TableCell, null, genres.join(", ")),
            React.createElement(TableCell, null, duration),
            React.createElement(TableCell, null, formatTrackDate(createdAt)),
            showIsrc && React.createElement(TableCell, null, ISRC),
            React.createElement(TableCell, null, isNormalized ? "Да" : "Нет"),
            React.createElement(TableCell, { className: classes.published }, isPublished ? "Да" : "Нет"),
            React.createElement(TableCell, null,
                React.createElement(IconButton, { size: "small", onClick: handleClick },
                    React.createElement(MoreVert, null)),
                React.createElement(Menu, { anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: close },
                    React.createElement(MenuItem, { onClick: function () {
                            isPublished ? onUnpublish() : onPublish();
                            close();
                        } }, isPublished ? "Убрать из публикации" : "Опубликовать"),
                    React.createElement(MenuItem, { component: Link, to: paths.admin.tracks.edit(id) }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                    React.createElement(MenuItem, { onClick: function () {
                            openGenreEditDialog();
                            close();
                        } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u0433"),
                    React.createElement(MenuItem, { className: classes.remove, onClick: function () {
                            onRemove();
                            close();
                        } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))),
        React.createElement(Dialog, null),
        React.createElement(GenreEditDialog, { checkedTracksIds: [id], initialGenreIds: genreIds, isOpen: isGenreEditDialogOpen, close: closeGenreEditDialog })));
};
